import Radio from "@mui/material/Radio";
import { observer } from 'mobx-react-lite';
import { useState } from "react";
import useClosable from "../../hooks/useClosable";
import { ClosableOrder } from "../../store/ClosableStore";
import Modal from "../Modal";
import { useSegmentedButtonsOverride } from "../SegmentedButtons";
import addLocationsStyles from "./AddLocations.module.css";
import AddSingleLocation from "./AddSingleLocation";
import UploadMultipleLocations from "./UploadMultipleLocations";

function AddLocations({ companyId, onClose }: IAddLocationsProps) {
    const [addLocationsMode, setAddLocationsMode] = useState(AddLocationsMode.AddSingleLocation);
    const [isUploadStarted, setIsUploadStarted] = useState(false);
    useSegmentedButtonsOverride("", () => { }, [], true);
    useClosable(ClosableOrder.High, onClose);

    return (
        <Modal midWidth header="Add Locations" onClose={onClose}>
            {!isUploadStarted && (
                <div className={addLocationsStyles.modeBlock}>
                    <label className={addLocationsStyles.modeButton}>
                        <Radio
                            checked={addLocationsMode === AddLocationsMode.AddSingleLocation}
                            onChange={() => setAddLocationsMode(AddLocationsMode.AddSingleLocation)}
                        />
                        <span>Add Single Location</span>
                    </label>
                    <label className={addLocationsStyles.modeButton}>
                        <Radio
                            checked={addLocationsMode === AddLocationsMode.UploadMultipleLocations}
                            onChange={() => setAddLocationsMode(AddLocationsMode.UploadMultipleLocations)}
                        />
                        <span>Upload Multiple Locations</span>
                    </label>
                </div>
            )}
            {addLocationsMode === AddLocationsMode.AddSingleLocation && (
                <AddSingleLocation
                    companyId={companyId}
                    onUploadStarted={() => setIsUploadStarted(true)}
                    onUploadCanceled={() => setIsUploadStarted(false)}
                    onClose={onClose}
                />
            )}
            {addLocationsMode === AddLocationsMode.UploadMultipleLocations && (
                <UploadMultipleLocations
                    companyId={companyId}
                    onUploadStarted={() => setIsUploadStarted(true)}
                    onUploadCanceled={() => setIsUploadStarted(false)}
                    onClose={onClose}
                />
            )}
        </Modal>
    );
}

interface IAddLocationsProps {
    companyId: number;
    onClose: () => void;
}

export enum AddLocationsMode {
    AddSingleLocation,
    UploadMultipleLocations,
}

export default observer(AddLocations);